import style from "./SideBarOffCanvasCustomMove.module.css";
import commonStyle from "../Style.module.css";
import * as GroupGameService from "../../api/GroupGameService";
import {useState} from "react";
import {useTranslation} from "react-i18next";


export default function SideBarOffCanvasCustomMove(props) {
    const { t, i18n } = useTranslation('translation', { keyPrefix: 'gameFieldOffCanvasCustomMove' });
    const [selectedPosition, setSelectedPosition] = useState(-1)

    function getOptionString(num) {
        if (num === 0) {
            return t('gameStart')
        }
        if (num === 68) {
            return t('endGame')
        }
        try {
            for (const card of props.cards) {
                if (card.field_number === num) {
                    return card.title
                }
            }
        } catch (e) {
            return ""
        }

    }

    function performMove() {
        setSelectedPosition(-1)
        GroupGameService.addCustomMove(props.gameId, props.selectedPlayerId, selectedPosition, () => {}, () => {})
    }


    return <div className={style.container}>
        <header className={commonStyle.h5Heading}>{t('movePlayerToPos')}</header>
        <select
            name="custom_move"
            id="add-custom-move-select"
            onChange={((evt) => setSelectedPosition(evt.target.value))}
            className={style.positionSelect}

        >
            <option value={-1}>{t('chosePos')}</option>
            {Array.from(Array(73).keys()).map((num) => {
                return <option key={num} value={num}>{num} - {getOptionString(num)}</option>
            })}
        </select>
        <button
            disabled={selectedPosition < 0}
            className={commonStyle.defaultButtonColourAndText}
            style={{
                padding: "10px",
                margin: "6px",
                marginLeft: 0
            }}
            onClick={performMove}
        >
            {t('move')}
        </button>

    </div>

}